import { createReducer } from '@reduxjs/toolkit'
import { ActionSuffixes } from "../constants/common/actions";

const initialState = { unhandledActions: 0 };

export default createReducer(initialState, builder => {
    builder
        .addMatcher(
            action => action.type.endsWith(ActionSuffixes._Set),
            (state, action) => {
                state[action.meta.prefix] = action.payload;
            }
        )
        .addDefaultCase((state, action) => {
            state.unhandledActions++;
        });
})